import type { JSX } from '@familyjs/core/components';
import { defineCustomElement } from '@familyjs/core/components/fml-toast.js';

import { createInlineOverlayComponent } from './createInlineOverlayComponent';

export const FmlToast = /*@__PURE__*/ createInlineOverlayComponent<JSX.FmlToast, HTMLFmlToastElement>(
  'fml-toast',
  defineCustomElement
);
